import produce from 'immer';

const INITIAL_STATE = {
  profile: null,
  loading: 0,
};

export default function beneficiarie(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@auth/SIGN_IN_SUCCESS': {
        draft.profile = action.payload.user;
        break;
      }
      case '@beneficiarie/UPDATE_PROFILE_REQUEST': {
        draft.loading = 1;
        break;
      }
      case '@beneficiarie/UPDATE_PROFILE_SUCCESS': {
        draft.profile = action.payload.profile;
        draft.loading = 0;
        break;
      }
      case '@beneficiarie/UPDATE_PROFILE_FAILURE': {
        draft.profile = action.payload.profile;
        draft.loading = 0;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.profile = null;
        break;
      }

      default:
    }
  });
}
